// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-content > *[data-v-ce5d5274]:not(:last-child) {
  margin-bottom: 0px !important;
}
.info-content[data-v-ce5d5274] {
  overflow-y: hidden;
}
.info-content[data-v-ce5d5274] > * {
  box-shadow: none !important;
}
.chatsearchwrapper[data-v-ce5d5274] {
  display: flex;
  height: 100%;
  overflow: hidden;
  position: relative;
  flex: 1;
}
.chatsearchwrapper .list-item[data-v-ce5d5274] {
  margin-bottom: 0px !important;
  box-shadow: none;
}
.chatsearchwrapper .list-item[data-v-ce5d5274]:hover {
  background-color: var(--content-container-bgcolor);
}
.chatsearchwrapper .chatsearchcontent[data-v-ce5d5274] {
  overflow-y: auto;
  height: 100%;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] {
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  margin-bottom: 0px !important;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item {
  width: 100%;
  border-bottom: 1px solid var(--hor-line-color);
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item .item-content {
  position: relative;
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
  justify-content: space-between;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item .item-media {
  margin-left: 6px;
  margin-right: 4px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom {
  height: 71px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 60px;
  max-width: 174px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .item-header {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 206px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text:first-child,
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .list-item .item-after:first-child,
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .list-item .item-link:first-child {
  margin-left: 4px;
  margin-right: 4px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .htswrapper {
  white-space: inherit;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-after {
  margin-right: 2px;
}
.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .resize-observer {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  border: none;
  background-color: transparent;
  pointer-events: none;
  display: block;
  overflow: hidden;
  opacity: 0;
}
.chatsearchwrapper .btnwrapper[data-v-ce5d5274] {
  display: flex;
  border-top: 1px solid var(--border-bottom-section);
  box-shadow: none;
  height: 54px;
  align-items: center;
  justify-content: center;
  padding: 2px;
  margin-right: 1px;
}
.chatsearchwrapper .btnwrapper .btn[data-v-ce5d5274] {
  width: 100%;
  height: 100%;
  color: var(--font-color);
  background-color: var(--list-item-bghover);
  border: none;
  outline: 0;
  margin: 0 auto;
}
.chatsearchwrapper .btnwrapper .btn[data-v-ce5d5274]:hover {
  opacity: 0.8;
}
.chatsearchwrapper .btnwrapper .loader[data-v-ce5d5274] {
  position: relative;
  width: 100%;
  opacity: 0.8;
}
.hor-line[data-v-ce5d5274] {
  height: 1px;
  background: var(--hor-line-color);
}
.dateTimeItems[data-v-ce5d5274] {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  padding-right: 4px;
}
[data-v-ce5d5274] .vue-recycle-scroller.ready .vue-recycle-scroller__item-view {
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/SearchChatMessages.vue"],"names":[],"mappings":"AAAA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kDAAkD;AACpD;AACA;EACE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,aAAa;EACb,kDAAkD;EAClD,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,WAAW;AACb","sourcesContent":[".info-content > *[data-v-ce5d5274]:not(:last-child) {\n  margin-bottom: 0px !important;\n}\n.info-content[data-v-ce5d5274] {\n  overflow-y: hidden;\n}\n.info-content[data-v-ce5d5274] > * {\n  box-shadow: none !important;\n}\n.chatsearchwrapper[data-v-ce5d5274] {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  flex: 1;\n}\n.chatsearchwrapper .list-item[data-v-ce5d5274] {\n  margin-bottom: 0px !important;\n  box-shadow: none;\n}\n.chatsearchwrapper .list-item[data-v-ce5d5274]:hover {\n  background-color: var(--content-container-bgcolor);\n}\n.chatsearchwrapper .chatsearchcontent[data-v-ce5d5274] {\n  overflow-y: auto;\n  height: 100%;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] {\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 100%;\n  margin-bottom: 0px !important;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item {\n  width: 100%;\n  border-bottom: 1px solid var(--hor-line-color);\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item .item-content {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  overflow: hidden;\n  justify-content: space-between;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item .item-media {\n  margin-left: 6px;\n  margin-right: 4px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom {\n  height: 71px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  max-height: 60px;\n  max-width: 174px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .item-header {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  max-width: 206px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text:first-child,\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .list-item .item-after:first-child,\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .item-text .list-item .item-link:first-child {\n  margin-left: 4px;\n  margin-right: 4px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-content .htswrapper {\n  white-space: inherit;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .list-item.listItemCustom .item-after {\n  margin-right: 2px;\n}\n.chatsearchwrapper .chatsearchcontent .scroller[data-v-ce5d5274] .resize-observer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  pointer-events: none;\n  display: block;\n  overflow: hidden;\n  opacity: 0;\n}\n.chatsearchwrapper .btnwrapper[data-v-ce5d5274] {\n  display: flex;\n  border-top: 1px solid var(--border-bottom-section);\n  box-shadow: none;\n  height: 54px;\n  align-items: center;\n  justify-content: center;\n  padding: 2px;\n  margin-right: 1px;\n}\n.chatsearchwrapper .btnwrapper .btn[data-v-ce5d5274] {\n  width: 100%;\n  height: 100%;\n  color: var(--font-color);\n  background-color: var(--list-item-bghover);\n  border: none;\n  outline: 0;\n  margin: 0 auto;\n}\n.chatsearchwrapper .btnwrapper .btn[data-v-ce5d5274]:hover {\n  opacity: 0.8;\n}\n.chatsearchwrapper .btnwrapper .loader[data-v-ce5d5274] {\n  position: relative;\n  width: 100%;\n  opacity: 0.8;\n}\n.hor-line[data-v-ce5d5274] {\n  height: 1px;\n  background: var(--hor-line-color);\n}\n.dateTimeItems[data-v-ce5d5274] {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  padding-right: 4px;\n}\n[data-v-ce5d5274] .vue-recycle-scroller.ready .vue-recycle-scroller__item-view {\n  position: absolute;\n  top: 0;\n  left: 0;\n  will-change: transform;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
